import {Component, Input, OnInit} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {ActivatedRoute} from "@angular/router";
import {BaseError} from "../base-error";
import {ClassificationType} from "../../../models/classification-type";

import {ToastrService} from "ngx-toastr";

@Component({
  selector: "classification",
  templateUrl: "./classification.component.html",
})

export class ClassificationComponent extends BaseError implements OnInit {

  public classificationTypes: ClassificationType[];
  public hideList: boolean = false;
  public hideServices: boolean = false;
  public numberClassifications: number = 0;
  public numberRejectionReasons: number = 0;
  public numberConditionTypes: number = 0;
  public determinantMapById: { [key: string]: string } = {};

  constructor(toastr: ToastrService,
              private title: Title,
              private route: ActivatedRoute) {
    super(toastr);
  }

  public ngOnInit() {
    this.title.setTitle("catalogue"); // quick fix - ideally we would want to do this through app.module
    this.route.params.subscribe((params) => {
      console.log("--- catalogs", params);
      this.hideServices = params.serviceId === undefined;
    });
  }

  public setClassificationsCounter(e) {
    this.numberClassifications = e ? Number(e) : 0;
  }

  public setRejectionReasonsCounter(e) {
    this.numberRejectionReasons = e ? Number(e) : 0;
  }

  public setConditionTypesCounter(e) {
    this.numberConditionTypes = e ? Number(e) : 0;
  }

  public onSelect(event) {
    this.hideList = false;
  }
}
